// extracted by mini-css-extract-plugin
export default {"success":"success-bJ5oP","error":"error-mQONe"};